import { Typography } from '@aloft/toolkit-sui';

import { Fragment } from 'react';

import { TdGap } from './TdGap.js';
import { PairedCostAdjustmentSummaryProps } from './types.js';

export const PairedCostAdjustmentSummaryTableSubheaderRow = ({
  compSequence,
  title,
  isSimplifiedMode: showSummaryColumn,
}: PairedCostAdjustmentSummaryProps & { title: string }) => (
  <tr>
    <th className="subheader-cell" colSpan={showSummaryColumn ? 3 : 2}>
      <Typography variant="h5" color="textPrimary">
        {title}
      </Typography>
    </th>
    {compSequence.map((compID, idx) => (
      <Fragment key={`column-title-${compID}`}>
        <TdGap isSticky={idx === 0} />
        <td className="subheader-cell" colSpan={2} />
      </Fragment>
    ))}
  </tr>
);
